import * as API from '../api'
import { generate_timestamp } from '../utils/timestamp'
import { openOrDownloadPdf } from '../utils/downloads'
import { numberFormater } from '../utils'

export const FETCH_INVENTORY_INPUT_LIST = 'FETCH_INVENTORY_INPUT_LIST'
export const FETCHING_INVENTORY_INPUT_LIST = 'FETCHING_INVENTORY_INPUT_LIST'
export const FETCH_INVENTORY_INPUT_LIST_ERROR = 'FETCH_INVENTORY_INPUT_LIST_ERROR'

export const ADDING_INVENTORY_INPUT = 'ADDING_INVENTORY_INPUT'
export const ADD_INVENTORY_INPUT = 'ADD_INVENTORY_INPUT'
export const ADD_INVENTORY_INPUT_ERROR = 'ADD_INVENTORY_INPUT_ERROR'

export const ADD_INVENTORY_OUTPUT = 'ADD_INVENTORY_OUTPUT'
export const ADDING_INVENTORY_OUTPUT = 'ADDING_INVENTORY_OUTPUT'
export const ADD_INVENTORY_OUTPUT_ERROR = 'ADD_INVENTORY_OUTPUT_ERROR'

export const EDITING_INVENTORY_INPUT = 'EDITING_INVENTORY_INPUT'
export const EDIT_INVENTORY_INPUT = 'EDIT_INVENTORY_INPUT'
export const EDIT_INVENTORY_INPUT_ERROR = 'EDIT_INVENTORY_INPUT_ERROR'

export const EDITING_INVENTORY_OUTPUT = 'EDITING_INVENTORY_OUTPUT'
export const EDIT_INVENTORY_OUTPUT = 'EDIT_INVENTORY_OUTPUT'
export const EDIT_INVENTORY_OUTPUT_ERROR = 'EDIT_INVENTORY_OUTPUT_ERROR'

export const FETCHING_DOWNLOAD_XLS = 'FETCHING_DOWNLOAD_XLS'
export const FETCH_DOWNLOAD_XLS = 'FETCH_DOWNLOAD_XLS'
export const FETCH_DOWNLOAD_XLS_ERROR = 'FETCH_DOWNLOAD_XLS_ERROR'

export const FETCHING_DOWNLOAD_PDF = 'FETCHING_DOWNLOAD_PDF'
export const FETCH_DOWNLOAD_PDF = 'FETCH_DOWNLOAD_PDF'
export const FETCH_DOWNLOAD_PDF_ERROR = 'FETCH_DOWNLOAD_PDF_ERROR'

export const FETCH_INVENTORY_HISTORIC = 'FETCH_INVENTORY_HISTORIC'
export const FETCHING_INVENTORY_HISTORIC = 'FETCHING_INVENTORY_HISTORIC'
export const FETCH_INVENTORY_HISTORIC_ERROR = 'FETCH_INVENTORY_HISTORIC_ERROR'

export const FETCH_HISTORIC_DOWNLOAD = 'FETCH_HISTORIC_DOWNLOAD'
export const FETCHING_HISTORIC_DOWNLOAD = 'FETCHING_HISTORIC_DOWNLOAD'
export const FETCH_HISTORIC_DOWNLOAD_ERROR = 'FETCH_HISTORIC_DOWNLOAD_ERROR'

export const CHANGE_STATUS_DOWNLOAD_ERROR = 'CHANGE_STATUS_DOWNLOAD_ERROR'

const enrichInventoryItems = items => {
  items.forEach(item => {
    if (item.minimum_stock)
      item.minimumStockWithMeasure = `${item.minimum_stock.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description || ''}`
    if (item.amount)
      item.batchCurrentStock = `${item.batch_current_stock.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description || ''}`
  })
  return items
}

export const fetchInventoryInputList = object => {
  return dispatch => {
    dispatch({
      type: FETCHING_INVENTORY_INPUT_LIST,
      value: true
    })
    return API.inventory
      .getInventoryInputList(object)
      .then(response => {
        const { data = {} } = response
        const { items = [], last_update, total_records, pagination } = data
        enrichInventoryItems(items)

        dispatch({
          type: FETCH_INVENTORY_INPUT_LIST,
          items,
          last_update,
          total_records,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_INVENTORY_INPUT_LIST_ERROR
        })
      })
  }
}

export const addInventoryInput = (inventoryInput, searchText, pagination) => {
  return dispatch => {
    dispatch({
      type: ADDING_INVENTORY_INPUT,
      value: true
    })

    const {
      userId,
      areaId,
      productId,
      batch,
      expiration_date,
      manufacturing_date,
      invoice,
      certificate,
      amount,
      amountPackage,
      observation,
      transaction_date,
      minimum_stock
    } = inventoryInput

    const inventory = {
      user_id: userId,
      area_id: areaId,
      product_id: productId,
      batch,
      expiration_date,
      manufacturing_date,
      invoice,
      certificate,
      amount,
      amount_package: amountPackage,
      observation,
      transaction_date,
      minimum_stock: numberFormater.stringToFloat(minimum_stock)
    }

    return API.inventory
      .addInventoryInput(inventory, searchText, pagination)
      .then(response => {
        const { data = {} } = response
        const { item, last_update } = data

        const { currentPage: page, rowsPerPage, orderBy, order } = pagination

        const object = { searchText, areaId: inventory.area_id, page, rowsPerPage, orderBy, order: order ? 'desc' : 'asc' }

        API.inventory
          .getInventoryInputList(object)
          .then(response => {
            const { items, pagination } = response.data
            enrichInventoryItems(items)
            dispatch({
              type: ADD_INVENTORY_INPUT,
              inventoryInput: item,
              last_update,
              items,
              pagination
            })
          })
      })
      .catch(err => {
        dispatch({
          type: ADD_INVENTORY_INPUT_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const addInventoryOutput = (inventoryOutput, searchText, pagination) => {
  return dispatch => {
    dispatch({
      type: ADDING_INVENTORY_OUTPUT,
      value: true
    })

    const {
      userId,
      areaId,
      productId,
      batch,
      amount,
      amountPackage,
      observation,
      transactionDate,
      invoice,
      certificate
    } = inventoryOutput

    const inventory = {
      user_id: userId,
      area_id: areaId,
      product_id: productId,
      batch,
      amount,
      amount_package: amountPackage,
      observation,
      transaction_date: transactionDate,
      invoice,
      certificate
    }
    return API.inventory
      .addInventoryOutput(inventory, searchText, pagination)
      .then(response => {
        const { last_update } = response.data
        const { currentPage: page, rowsPerPage, orderBy, order } = pagination

        const object = { searchText, areaId: inventory.area_id, page, rowsPerPage, orderBy, order: order ? 'desc' : 'asc' }

        API.inventory
          .getInventoryInputList(object)
          .then(response => {
            const { items, pagination } = response.data
            enrichInventoryItems(items)

            dispatch({
              type: ADD_INVENTORY_OUTPUT,
              last_update,
              items,
              pagination
            })
          })
      })
      .catch(err => {
        dispatch({
          type: ADD_INVENTORY_OUTPUT_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const editInventoryInput = (inventoryInput, searchText, pagination) => {
  return dispatch => {
    dispatch({
      type: EDITING_INVENTORY_INPUT,
      value: true
    })

    const {
      id,
      areaId,
      expiration_date,
      manufacturing_date,
      invoice,
      certificate,
      observation,
      minimum_stock
    } = inventoryInput

    const inventory = {
      id,
      area_id: areaId,
      expiration_date,
      manufacturing_date,
      invoice,
      certificate,
      observation,
      minimum_stock: numberFormater.stringToFloat(minimum_stock)
    }

    return API.inventory
      .editInventoryInput(inventory, searchText, pagination)
      .then(response => {
        const { last_update } = response.data
        const { currentPage: page, rowsPerPage, orderBy, order } = pagination

        const object = { searchText, areaId: inventory.area_id, page, rowsPerPage, orderBy, order: order ? 'desc' : 'asc' }

        API.inventory
          .getInventoryInputList(object)
          .then(response => {
            const { items, pagination } = response.data
            enrichInventoryItems(items)

            dispatch({
              type: EDIT_INVENTORY_INPUT,
              items,
              last_update,
              pagination
            })
          })
      })
      .catch(err => {
        dispatch({
          type: EDIT_INVENTORY_INPUT_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const editInventoryOutput = inventoryOutput => {
  return dispatch => {
    dispatch({
      type: EDITING_INVENTORY_OUTPUT,
      value: true
    })

    const { id, areaId, invoice, certificate } = inventoryOutput

    const inventory = {
      id,
      area_id: areaId,
      invoice,
      certificate
    }

    // A saída não aparece na listagem de entradas, então só precisamos atualizar
    // o last_update — não há lista para refazer fetch.
    return API.inventory
      .editInventoryOutput(inventory)
      .then(response => {
        dispatch({
          type: EDIT_INVENTORY_OUTPUT,
          last_update: response.data.last_update
        })
      })
      .catch(err => {
        dispatch({
          type: EDIT_INVENTORY_OUTPUT_ERROR
        })

        return Promise.reject(err)
      })
  }
}

export const getProductHistoric = object => {
  return API.inventory.getProductHistoric(object).then(response => {
    const { data = {} } = response
    const { items = [] } = data
    items.map(item => {
      if (item.amount) {
        if (item.amount < 0) item.amount = item.amount * -1
        item.amount = `${item.amount.toLocaleString('pt-BR', { minimumFractionDigits: 5 })} ${item.product_measure_description || ''}`
      }
    })
    return response.data
  })
}

export const fetchDownloadXls = (searchText, areaId) => {
  return dispatch => {
    dispatch({
      type: FETCHING_DOWNLOAD_XLS
    })

    return API.inventory
      .downloadXls(searchText, areaId)
      .then(response => {
        const filename = 'Estoque de Produtos Químicos ' + generate_timestamp() + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const createLink = () => {
          const link = document.createElement('a')

          if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', filename)

            link.style = 'visibility: hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }

        dispatch({
          type: FETCH_DOWNLOAD_XLS
        })

        return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
      })
      .catch(err => {
        dispatch({
          type: FETCH_DOWNLOAD_XLS_ERROR
        })
      })
  }
}

export const fetchDownloadPdf = (searchText, areaId) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    return API.inventory
      .downloadPdf(searchText, areaId)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename = 'Estoque de Produtos ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}

export const changeStatusDownloadError = () => {
  return dispatch => {
    dispatch({ type: CHANGE_STATUS_DOWNLOAD_ERROR })
  }
}

export const fetchInventoryHistoric = object => {
  return dispatch => {
    dispatch({
      type: FETCHING_INVENTORY_HISTORIC,
      value: true
    })

    return API.inventory
      .getInventoryHistoric(object)
      .then(response => {
        const { data = {} } = response
        const { items = [], last_update, pagination } = data

        dispatch({
          type: FETCH_INVENTORY_HISTORIC,
          items,
          last_update,
          pagination
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_INVENTORY_HISTORIC_ERROR
        })
      })
  }
}

export const fetchHistoricDownloadXls = areaId => {
  return dispatch => {
    dispatch({
      type: FETCHING_DOWNLOAD_XLS
    })

    return API.inventory
      .getDownloadHistoricXLS(areaId)
      .then(response => {
        const filename = 'Histórico de Movimentação de Estoque ' + generate_timestamp() + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const createLink = () => {
          const link = document.createElement('a')

          if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', filename)

            link.style = 'visibility: hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }

        dispatch({
          type: FETCH_DOWNLOAD_XLS
        })

        return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
      })
      .catch(err => {
        dispatch({
          type: FETCH_DOWNLOAD_XLS_ERROR
        })
      })
  }
}

export const fetchProductHistoricDownloadXls = (areaId, productId, batch) => {
  return dispatch => {
    dispatch({
      type: FETCHING_DOWNLOAD_XLS
    })

    return API.inventory
      .getDownloadProductHistoricXLS(areaId, productId, batch)
      .then(response => {
        const filename =
          'Histórico de Movimentação de Produtos em Estoque ' + generate_timestamp() + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const createLink = () => {
          const link = document.createElement('a')

          if (link.download !== undefined) {
            const url = window.URL.createObjectURL(blob)

            link.setAttribute('href', url)
            link.setAttribute('download', filename)

            link.style = 'visibility: hidden'

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }

        dispatch({
          type: FETCH_DOWNLOAD_XLS
        })

        return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
      })
      .catch(err => {
        dispatch({
          type: FETCH_DOWNLOAD_XLS_ERROR
        })
      })
  }
}

export const fetchHistoricDownloadPdf = areaId => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    return API.inventory
      .getDownloadHistoricPDF(areaId)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename = 'Histórico de Movimentação de Estoque ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}

export const fetchProductHistoricDownloadPdf = (areaId, productId, batch) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    return API.inventory
      .getDownloadProductHistoricPDF(areaId, productId, batch)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename =
          'Histórico de Movimentação de Produtos em Estoque ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}

export const fetchDownloadProductInventoryHistoricXLS = ({ areaId, productId, productName, initial_date, final_date }) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_XLS })

    return API.inventory
    .getDownloadProductInventoryHistoricXLS(areaId, productId, initial_date, final_date)
    .then(response => {
      const filename =
      'Histórico de Movimentação de '+ (productName || 'Produto') +' em Estoque ' + generate_timestamp() + '.xlsx'

        
      const blob = new Blob([response.data], {
        type: 'application/xlsx',
        charset: 'UTF-8'
      })

      const createLink = () => {
        const link = document.createElement('a')

        if (link.download !== undefined) {
          const url = window.URL.createObjectURL(blob)

          link.setAttribute('href', url)
          link.setAttribute('download', filename)

          link.style = 'visibility: hidden'

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }

      dispatch({
        type: FETCH_DOWNLOAD_XLS
      })

      return (navigator.msSaveBlob && navigator.msSaveBlob(blob, filename)) || createLink()
    })
    .catch(err => {
      dispatch({
        type: FETCH_DOWNLOAD_XLS_ERROR
      })
    })
  }
}

export const fetchDownloadProductInventoryHistoricPDF = ({ areaId, productId, productName, initial_date, final_date }) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    return API.inventory
      .getDownloadProductInventoryHistoricPDF(areaId, productId, initial_date, final_date)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename =
          'Histórico de Movimentação de '+ (productName || 'Produto') +' em Estoque ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      })
      .catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/inventory.js